import { render, staticRenderFns } from "./EtapaEscalas.vue?vue&type=template&id=70af0756&scoped=true"
import script from "./EtapaEscalas.vue?vue&type=script&lang=js"
export * from "./EtapaEscalas.vue?vue&type=script&lang=js"
import style0 from "./EtapaEscalas.vue?vue&type=style&index=0&id=70af0756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af0756",
  null
  
)

export default component.exports